<template>
  <div 
    class="fill-height">
    <v-layout wrap>
      <v-flex>
        <section>
          <v-row
            class="pa-4 pb-2 pr-1">
            <v-col
              cols="12">
              <v-card
                to="/user"
                flat
                color="transparent"
                style="width: 20%;">
                <div
                  class="d-flex align-center">
                  <v-avatar
                    tile
                    size="28"
                    style="opacity: 30%;">
                    <v-img
                      contain
                      alt="kominfoklaten"  
                      :src="require('@/assets/icon/back_arrow.png')">
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height"
                          align="center"
                          justify="center">
                          <v-progress-circular 
                            size="20"
                            indeterminate 
                            :color="set_color">
                          </v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                  </v-avatar>

                  <span
                    class="title black--text ml-3"
                    style="font-weight: 600;">
                    Tambah Pegawai
                  </span>
                </div>
              </v-card>
            </v-col>
          </v-row>

          <v-row
            class="pa-4 pr-1">
            <v-col 
              cols="12"
              class="py-0">
              <v-card 
                flat
                min-height="calc(100vh - 245px)"
                style="border-radius: 10px; border: 1px solid #E7E7E7; overflow-y: auto;">
                <v-card-text>
                  <ValidationObserver 
                    ref="form">
                    <v-form>
                      <div
                        class="mb-4">
                        <div 
                          class="body-2 mb-2">
                          Poto Profil
                        </div>

                        <uploadfolder v-if="form.image_url === ''"
                          v-model="upload.image">
                          <div 
                            slot="activator">
                            <v-card 
                              flat
                              width="200"
                              height="200"
                              class="d-flex align-center justify-center cursor-pointer"
                              style="border-radius: 15px;
                                    border: 2px solid #EBEBEB; 
                                    border-style: dashed;">
                              <v-avatar v-if="!process.image"
                                v-ripple
                                tile 
                                width="200"
                                height="200">
                                <v-icon
                                  size="50"
                                  color="#B9B9B9">
                                  mdi-cloud-upload-outline
                                </v-icon>
                              </v-avatar>

                              <v-progress-circular v-else
                                indeterminate
                                :color="set_color">
                              </v-progress-circular>
                            </v-card>
                          </div>
                        </uploadfolder>

                        <v-card v-if="form.image_url !== ''"
                          flat
                          width="200"
                          height="200"
                          class="d-flex align-center justify-center"
                          style="border-radius: 15px;
                                border: 2px solid #EBEBEB; 
                                border-style: dashed;">
                          <v-avatar
                            v-ripple
                            tile 
                            size="200"
                            style="border-radius: 15px;">
                            <v-img 
                              contain
                              width="100%"
                              height="100%"
                              alt="kominfoklaten" 
                              :src="form.image_url"
                              class="ma-auto"
                              style="border-radius: 15px;">
                              <template v-slot:placeholder>
                                <v-row
                                  class="fill-height"
                                  align="center"
                                  justify="center">
                                  <v-progress-circular 
                                    indeterminate 
                                    :color="set_color">
                                  </v-progress-circular>
                                </v-row>
                              </template>
                            </v-img>
                          </v-avatar>

                          <v-icon 
                            @click="form.image_url = ''"
                            color="red"
                            class="cursor-pointer"
                            style="position: absolute; top: -10px; right: -10px;">
                            mdi-close-circle
                          </v-icon>
                        </v-card>
                      </div>

                      <v-row>
                        <v-col
                          cols="12"
                          md="6">
                          <ValidationProvider 
                            name="Nama Lengkap" 
                            rules="required" 
                            v-slot="{ errors, valid }">
                            <div class="body-2 mb-2">
                              <span class="red--text">*</span>

                              Nama Lengkap
                            </div>

                            <v-text-field
                              v-on:keyup.enter="save()"
                              
                              filled
                              rounded
                              dense

                              :color="set_color"
                              placeholder="Contoh. John Doe"

                              hide-details

                              v-model="form.name"
                              :success="valid"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                              <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    {{ errors[0] }}
                                  </v-tooltip>
                                </div>
                                
                                <div v-if="form.name !== '' && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template>
                            </v-text-field>
                          </ValidationProvider>
                        </v-col>

                        <!-- <v-col
                          cols="12"
                          md="6">
                          <ValidationProvider 
                            name="Nomor Induk Pegawai" 
                            rules="required" 
                            v-slot="{ errors, valid }">
                            <div class="body-2 mb-2">
                              <span class="red--text">*</span>

                              Nomor Induk Pegawai
                            </div>

                            <v-text-field
                              v-on:keyup.enter="save()"
                              
                              filled
                              rounded
                              dense
                              
                              :color="set_color"
                              placeholder="Contoh. 3102XXX"
                              
                              hide-details

                              v-model="form.nip"
                              :success="valid"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                              <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    {{ errors[0] }}
                                  </v-tooltip>
                                </div>
                                
                                <div v-if="form.nip !== '' && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template>
                            </v-text-field>
                          </ValidationProvider>
                        </v-col> -->
                      </v-row>

                      <v-row>
                        <v-col
                          cols="12"
                          md="6">
                          <ValidationProvider 
                            name="Email" 
                            rules="required|email" 
                            v-slot="{ errors, valid }">
                            <div class="body-2 mb-2">
                              <span class="red--text">*</span>

                              Email
                            </div>

                            <v-text-field
                              v-on:keyup.enter="save()"
                              
                              filled
                              rounded
                              dense

                              :color="set_color"
                              placeholder="Contoh. XXXX@gmail.com"

                              hide-details

                              v-model="form.email"
                              :success="valid"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                              <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    {{ errors[0] }}
                                  </v-tooltip>
                                </div>
                                
                                <div v-if="form.email !== '' && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template>
                            </v-text-field>
                          </ValidationProvider>
                        </v-col>

                        <v-col
                          cols="12"
                          md="6">
                          <ValidationProvider 
                            name="Mobilephone" 
                            rules="required|min:10|max:13" 
                            v-slot="{ errors, valid }">
                            <div class="body-2 mb-2">
                              <span class="red--text">*</span>

                              Mobilephone
                            </div>

                            <v-text-field
                              v-on:keyup.enter="save()"
                              
                              filled
                              rounded
                              dense

                              onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                              type="number"
                              min="0"

                              :color="set_color"
                              placeholder="Contoh. 081XXXXXXXXX"

                              hide-details

                              v-model="form.mobilephone"
                              :success="valid"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                              <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    {{ errors[0] }}
                                  </v-tooltip>
                                </div>
                                
                                <div v-if="form.mobilephone !== '' && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template>
                            </v-text-field>
                          </ValidationProvider>
                        </v-col>
                      </v-row>

                      <!-- <v-row>
                        <v-col
                          cols="12"
                          md="6">
                          <ValidationProvider 
                            name="Jenis Kelamin" 
                            rules="required"
                            v-slot="{ errors, valid }">
                            <div class="body-2 mb-2">
                              <span class="red--text">*</span>
                              
                              Jenis Kelamin
                            </div>

                            <v-select
                              v-on:keyup.enter="save()"

                              filled
                              rounded
                              dense

                              :color="set_color"
                              placeholder="Contoh. Laki-Laki"

                              hide-details

                              :items="['Laki-Laki', 'Perempuan']"
                              :item-color="set_color"

                              v-model="form.gender"
                              :success="valid"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                              <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    {{ errors[0] }}
                                  </v-tooltip>
                                </div>
                                
                                <div v-if="form.gender !== '' && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template>
                            </v-select>
                          </ValidationProvider>
                        </v-col>
                      </v-row> -->

                      <v-row>
                        <v-col
                          cols="12"
                          md="6"
                          class="pb-0">
                          <div
                            class="body-2 font-weight-bold black--text">
                            #Kelengkapan
                          </div>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col
                          cols="12"
                          md="6">
                          <ValidationProvider 
                            name="Unit"
                            rules="required"  
                            v-slot="{ errors, valid }">
                            <div class="body-2 mb-2">
                              <span class="red--text">*</span>

                              Unit
                            </div>

                            <v-autocomplete
                              v-on:keyup.enter="save()"

                              filled
                              rounded
                              dense

                              :color="set_color"
                              placeholder="Contoh. Badan Pengelolaan Keuangan"

                              hide-details

                              :items="unit"
                              item-text="title"
                              item-value="id"
                              :item-color="set_color"

                              v-model="form.unit_id"
                              :success="form.unit_id !== '' && valid"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                              <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    {{ errors[0] }}
                                  </v-tooltip>
                                </div>
                                
                                <div v-if="form.unit_id !== '' && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template>
                            </v-autocomplete>
                          </ValidationProvider>
                        </v-col>

                        <v-col
                          cols="12"
                          md="6">
                          <ValidationProvider 
                            name="Role"
                            rules="required"  
                            v-slot="{ errors, valid }">
                            <div class="body-2 mb-2">
                              <span class="red--text">*</span>

                              Role
                            </div>

                            <v-select
                              v-on:keyup.enter="save()"

                              filled
                              rounded
                              dense

                              :color="set_color"
                              placeholder="Contoh. Admin"

                              hide-details

                              :items="[
                                {
                                  text: 'Admin',
                                  value: 'admin'
                                },
                                {
                                  text: 'OPD',
                                  value: 'opd'
                                }
                              ]"
                              item-text="text"
                              item-value="value"
                              :item-color="set_color"

                              v-model="form.role"
                              :success="form.role !== '' && valid"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                              <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    {{ errors[0] }}
                                  </v-tooltip>
                                </div>
                                
                                <div v-if="form.role !== '' && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template>
                            </v-select>
                          </ValidationProvider>
                        </v-col>
                      </v-row>
                    </v-form>
                  </ValidationObserver>

                  <div v-if="message.error.length > 0"
                    class="text-center my-4 d-flex align-center">
                    <div
                      class="error--text">
                      <v-icon size="18" color="red">mdi-alert-circle-outline</v-icon>
                      
                      <span
                        class="ml-1">
                        {{ message.error }}
                      </span>
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <v-row
            justify="end"
            class="pa-4 pr-1">
            <v-col 
              cols="12"
              md="12"
              class="d-flex align-center justify-end py-0">
              <v-btn
                @click="save()"
                :loading="process.form"
                :disabled="process.form"
                color="#4B4B4B"
                elevation="0"
                class="body-2 white--text text-capitalize d-flex align-center"
                style="border-radius: 10px; font-weight: 600; background: linear-gradient(180deg, rgba(63, 148, 62, 1), rgba(22, 115, 20, 1));">
                <v-icon
                  size="20">
                  mdi-checkbox-marked-circle-outline
                </v-icon>

                <span
                  class="ml-2">
                  Simpan
                </span>
              </v-btn>
              
              <v-btn
                to="/user"
                :disabled="process.form"
                color="red"
                elevation="0"
                class="body-2 white--text text-capitalize d-flex align-center ml-4"
                style="border-radius: 10px; font-weight: 600;">
                <v-icon 
                  size="20">
                  mdi-progress-close
                </v-icon>

                <span
                  class="ml-2">
                  Batal
                </span>
              </v-btn>
            </v-col>
          </v-row>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    data () {
      return {
        unit: [],

        form: {
          nip: '',
          name: '',
          email: '',
          mobilephone: '',
          gender: '',
          image_url: '',
          
          unit_id: '',
          unit_title: '',

          role: ''
        },

        upload: {
          image: null
        },

        process: {
          form: false,

          image: false
        },
        
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      uploadfolder: () => import(/* webpackPrefetchCategory: true */ '@/components/upload/folder.vue')
    },
    watch: {
      'upload.image': {
        handler: function () {
          if (this.upload.image) {
            this.process.image = this.upload.image.process

            if (!this.process.image) {
              // CALLBACK FROM UPLOAD IMAGE
              
              this.form.image_url = this.upload.image.fileuri
            }
          }
        },
        deep: true
      },

      'form.unit_id': function () {
        let t = this

        let u = this.unit.filter(function(v) {
          return t.form.unit_id == v.id
        })

        if (u.length > 0) {
          this.form.unit_title = u[0].title
        }
      }
    },
    computed: {
      user () {
        return this.$store.state.user
      },
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      }
    },
    mounted () {
      this.fetch()
    },
    methods: {
      async fetch () {
        let params = {
          limit: 100000,
          year: new Date().getFullYear()
        }
        
        await get('admin/unit/data', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.unit = res.results.data
          }
        })
      },

      async save () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()
        if (isValid) {
          this.process.form = true

          // SAVE TO REST API
          await post(`admin/user/add`, {
            data: this.form
          })
          .then((response) => {
            let res = response.data

            this.process.form = false

            if (res.status === 200) {

              this.$router.push({ path: '/user' })

            } else {
              this.message.error = res.message
            }
          })
          
        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      }
    }
  }
</script>